<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />

    <div class="right-menu">
      <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="click"
      >
        <div class="avatar-wrapper">
          <img src="~@/assets/img/home/photo.png" class="user-avatar" />
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/reset">
            <el-dropdown-item >重置密码</el-dropdown-item>
          </router-link>
          <el-dropdown-item divided @click.native="loginOut">
            <span style="display: block">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";

export default {
  components: {
    Breadcrumb,
    Hamburger,
  },
  computed: {
    ...mapGetters({
      sidebar: "app/sidebar",
      device: "app/device",
      token: "user/token",
      userInfo: "user/userInfo",
    }),
  },
  methods: {
    ...mapActions({
      toggleSideBar: "app/toggleSideBar",
    }),
    resetPassword(){
      this.$router.push("/reset")
    },
    loginOut() {
      // 退出登录
      this.$msgB(
        "您确定要退出登录吗？",
        "",
        "",
        () => {
          this.$api.other
            .loginOut({
              userId: this.userInfo.id,
              token: this.token,
            })
            .then((res) => {
              this.$removeStorage();
              this.$router.push("/login");
            });
        },
        true
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        padding-top: 5px;
        display: flex;
        align-items: center;
        &:hover {
          cursor: pointer;
        }
        .user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }
        .el-icon-caret-bottom {
          font-size: 12px;
          padding-left: 5px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Navbar.vue